import { useState, useEffect } from 'react';
import { isExpiredJwt, removeCookies, IsMbrTempRole, basePort, headers, setCookie, getJwtFromCookies, getRoleJwt, renderRedirect } from "../module_auth/AuthService"
import { LoginMethod } from "../component/common/EnumContainer.ts"
import { useNavigate } from "react-router-dom";
import { ToastMessage, ToastDangerMessage } from "../component/common/Toast"
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from 'jwt-decode';
import { useLocation } from "react-router-dom";
import { sendGoogleAnalytics } from '../component/common/BaseUtil.jsx';

export function LogIn() {
    const location = useLocation();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [jwtToken, setJwtToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    //const [showAlert, setShowAlert] = useState(false);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    //toastDanger
    const [showToastDanger, setShowToastDanger] = useState(false);
    const [msgToastDanger, setMsgToastDanger] = useState("");

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        if(getJwtFromCookies() != null && !isExpiredJwt(getJwtFromCookies())){
            removeCookies()
            setRedirect(true)
        } else {
            setRedirect(false)
        }
    }, []);

    function clickSubmit(event) {
        event.preventDefault();
        const jwtRequest = {
            username:email,
            password:password,
            loginMethod:LoginMethod.Manual
        }
        fetch(basePort + '/authenticate', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response.json())
                .then(response => {
                    if(response.validRequest){
                        setCookie(response.jwtToken)
                        if(IsMbrTempRole(getJwtFromCookies())){
                            removeCookies()
                            validateMbr()
                        } else {
                            fadeOutToast(response.validationMessage)
                            setTimeout(function() {
                                moveTo()
                            }.bind(this), 1000)
                        }
                    } else {
                        fadeOutToastDanger(response.validationMessage)
                    }
            }).catch(error => console.log(error))
    }

    function loginBy3rd(credentialResponse) {
        const decoded = jwtDecode(credentialResponse.credential);
        const jwtRequest = {
            username:decoded.email,
            loginMethod:LoginMethod.Third
        }
        fetch(basePort + '/authenticate', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response.json())
                .then(response => {
                    if(response.validRequest){
                        setCookie(response.jwtToken)
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 1000)
                    } else {
                        fadeOutToastDanger(response.validationMessage)
                    }
            }).catch(error => console.log(error))
    }

    function fadeOutToastDanger(msg){
        setToastDangerMessage(true, msg)
        setTimeout(function() {
            setToastDangerMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastDangerMessage(show, message){
        setShowToastDanger(show)
        setMsgToastDanger(message)
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    let navigate = useNavigate();
    function validateMbr() {
        let url = "/mbr_pv_reg_validation"
        navigate(url);
    }

    function moveTo() {
        setTimeout(function() {
            if(getRoleJwt(getJwtFromCookies()) === "ROLE_CP"){
                navigate("/mbr_cp_mypage");
            } else if(getRoleJwt(getJwtFromCookies()) === "ROLE_PV"){
                navigate("/mbr_pv_mypage");
            } else if(getRoleJwt(getJwtFromCookies()) === "ROLE_ADMIN"){
                navigate("/mbr_admin_page");
            }
            window.location.reload();
        }.bind(this), 3000)
    }

    function handleEmail(event) {
        setEmail(event.target.value)
        console.log(event.target.value)
    }

    function handlePassword(event) {
        setPassword(event.target.value)
    }

    function clickMbrSelect() {
        let url = "/mbr_select";
        navigate(url);
    }

    function clickFindId() {
        let url = "/find_userid";
        navigate(url);
    }

    function clickFindPassword() {
        let url = "/find_pwd";
        navigate(url);
    }

    return (
        <div>
            {renderRedirect(redirect, '/')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row mb-5">
                            <div class="col-md-8 col-xl-6 text-center mx-auto">
                                <h2>로그인</h2>
                                <p></p>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6 col-xl-4" style={{width: '600px'}}>
                                <div class="card mb-5">
                                    <div class="card-body d-flex flex-column align-items-center">
                                        <div class="bs-icon-xl bs-icon-circle bs-icon-primary bs-icon my-4"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-person">
                                                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"></path>
                                            </svg></div>
                                        <form class="text-center" method="post">
                                            <div class="mb-3"><input class="form-control" type="email" name="email" placeholder="Email" onChange={handleEmail}/></div>
                                            <div class="mb-3"><input class="form-control" type="password" name="password" placeholder="Password" onChange={handlePassword}/></div>
                                            <div class="mb-3">
                                                <button class="btn btn-primary d-block w-100" type="submit" onClick={clickSubmit}>Login</button>
                                            </div>
                                            {/* <button class="btn d-block w-100" type="submit" onClick={clickFindPassword}>비밀번호찾기</button>
                                            <button class="btn d-block w-100" type="submit" onClick={clickFindId}>아이디 찾기</button>
                                            <button class="btn d-block w-100" type="submit" onClick={clickMbrSelect}>회원가입</button> */}
                                        </form>
                                        {/* <AlertDanger show={showAlert} msg={"login failed"} /> */}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <GoogleLogin
                                        onSuccess={credentialResponse => {
                                            loginBy3rd(credentialResponse);
                                        }}
                                        onError={() => {
                                            fadeOutToast('Login Failed');
                                        }}
                                        text='signin_with'
                                        locale='ko'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <button type="button" class="btn btn-primary" id="liveToastBtn" onClick={clickBtn}>테스트버튼</button> */}
                    <ToastMessage show={showToast} msg={msgToast}/>
                    <ToastDangerMessage show={showToastDanger} msg={msgToastDanger}/>
                </section>
            </main>
        </div>
    );
}